export enum EducationalLevelEnum {
  LessThanHighSchool = 'LESS_THAN_HIGH_SCHOOL',
  HighSchool = 'HIGH_SCHOOL',
  PostSecondaryCertificate = 'POST_SECONDARY_CERTIFICATE',
  SomeCollegeCourses = 'SOME_COLLEGE_COURSES',
  AssociatesDegree = 'ASSOCIATES_DEGREE',
  BachelorsDegree = 'BACHELORS_DEGREE',
  PostBaccalaureateCertificate = 'POST_BACCALAUREATE_CERTIFICATE',
  MastersDegree = 'MASTERS_DEGREE',
  PostMastersCertificate = 'POST_MASTERS_CERTIFICATE',
  FirstProfessionalDegree = 'FIRST_PROFESSIONAL_DEGREE',
  DoctoralDegree = 'DOCTORAL_DEGREE',
  PostDoctoralTraining = 'POST_DOCTORAL_TRAINING'
}
